import { call, put, takeEvery } from 'redux-saga/effects';
import normalize from 'jsonapi-normalizer';
import { meetings } from '../../../api';
import { resourceReducer } from '../../utils/resourceReducer';
export const [actions, reducer, resourceSagas] = resourceReducer('meetings');

// Create the sagas for this entity
function* readMeetings() {
  yield takeEvery(actions.indexRequestBegin, function* () {
    try {
      const result = yield call(meetings.get);
      const normalized = normalize(result);
      yield put(actions.indexRequestSuccess(normalized));
    } catch (error) {
      yield put(actions.indexRequestFailure({ error }));
      yield put({ type: 'ERRORS/HANDLE_API_ERROR', payload: error });
    }
  });
}

export const sagas = [readMeetings, ...resourceSagas];
